import Axios from "./axios"  // 导入配置好的axios文件
// 封装axios请求函数，并用export导出
export function login(datas) {
  let loginParams = {
                      "M_PRO_NAME":"PROC_PC_LOGIN"
                    }
  Object.assign(datas,loginParams)
  return Axios({
    url: "/call",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}

export function loginToken(datas) {
  Object.assign(datas)
  return Axios({
    url: "/login",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}


// export function login(datas) {
//   // let loginParams = {
//   //   "M_PRO_NAME":"PROC_PC_LOGIN"
//   // }
//   // Object.assign(datas,loginParams)
//   return Axios({
//     url: "/login",
//     method: "post",
//     headers: {
//       'Content-Type': 'application/json' //设置请求头请求格式form
//     },
//     data: datas
//   })
// }

export function billOrders(datas) {
  let loginParams = {
    "M_PRO_NAME":"PROC_PC_DKXD"
  }
  Object.assign(datas,loginParams)
  return Axios({
    url: "/call",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}

export function billCheckOrders(datas) {
  let loginParams = {
    "M_PRO_NAME":"PROC_PC_BILLCHECK"
  }
  Object.assign(datas,loginParams)
  return Axios({
    url: "/call",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}


export function getBillNo(datas) {
  return Axios({
    url: "/bill",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}


export function saveBill(datas) {
  return Axios({
    url: "/billSave",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}

export function saveTable(datas) {
  return Axios({
    url: "/tableSave",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}

export function getClass(datas) {
  return Axios({
    url: "/getClass",
    method: "post",
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式form
    },
    data: datas
  })
}




// WEBPACK FOOTER //
// ./src/api/index.js